import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import HudsonLogo from '../images/hudson-logo.png';
import { useHistory } from 'react-router-dom';
import { NotFoundIcon } from '../components/icons';

export const TopBarStyles = styled.div`
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0bcb4;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  height: 70px;
  @media (min-width: 768px) {
    padding: 0 40px;
  }
  @media (min-width: 1024px) {
    padding: 0 70px;
  }
  @media (min-width: 1700px) {
    padding: 0 230px;
  }
`;

const NotFound = () => {
  const history = useHistory();
  const onHomeClick = () => {
    history.push('/home');
  };
  return (
    <div>
      <TopBarStyles>
        <div onClick={onHomeClick} style={{ cursor: 'pointer' }}>
          <img src={HudsonLogo} style={{ width: 'auto', height: 48 }} alt="" />
        </div>
      </TopBarStyles>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 100 }}>
        <div style={{ flexDirection: 'column' }}>
          <NotFoundIcon />
          <h3 style={{ justifyContent: 'center', display: 'flex', marginTop: 30 }}>
            This page was not found
          </h3>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
            <Link to="/home">
              <Button buttonText="Home" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
